import UPA from 'actions/updatePasswordActions';
import { RSAA } from 'redux-api-middleware';
import moment from 'moment';

export const updatePassword = (type, input) => ({ type: UPA.UPDATE_PASSWORD, payload: { type, input }});

export const updateNewPassword = (token, newPassword) => ({ [RSAA]: {
    endpoint: '/user/reset',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        timeStamp: moment.utc().unix(),
        messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b76',
        password: newPassword,
        token: token
    }),
    types: [
        UPA.UPDATE_NEW_PASSWORD_PENDING,
        UPA.UPDATE_NEW_PASSWORD_SUCCESS,
        UPA.UPDATE_NEW_PASSWORD_FAILURE
    ]
}});

export const updateExpiredPassword = (userName, oldPassword, newPassword) => ({ [RSAA]: {
    endpoint: '/user/resetPassword',
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
        timeStamp: moment.utc().unix(),
        messageUuid: 'e60299b0-e039-4a05-bb58-ea49e6795b76',
        oldPassword: oldPassword,
        password: newPassword,
        id: userName
    }),
    types: [
        UPA.UPDATE_EXPIRED_PASSWORD_PENDING,
        UPA.UPDATE_EXPIRED_PASSWORD_SUCCESS,
        UPA.UPDATE_EXPIRED_PASSWORD_FAILURE
    ]
}});

export const resetEmail = p => ({ [RSAA]: {
    endpoint: '/user/resetEmail',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(p),
    types: [
        UPA.UPDATE_NEW_EMAIL_PENDING,
        UPA.UPDATE_NEW_EMAIL_SUCCESS,
        UPA.UPDATE_NEW_EMAIL_FAILURE
    ]
}});
